// extracted by mini-css-extract-plugin
export var buttons = "_91-0";
export var buttonsActive = "_91-h";
export var cancelConfirm = "_91-1";
export var closeButton = "_91-2";
export var column = "_91-3";
export var container = "_91-4";
export var detailHeader = "_91-6";
export var detailTitle = "_91-7";
export var detailsContent = "_91-5";
export var header = "_91-8";
export var headerWithClose = "_91-9";
export var icon = "_91-a";
export var infoIcon = "_91-c";
export var informationContainer = "_91-b";
export var sideDrawer = "_91-d";
export var sideDrawerOpen = "_91-e";
export var stickyFooter = "_91-f";
export var typeOption = "_91-g";